import crudHandlers from './_crud'

const initialState = {
	entities: {},
	_pagination: {
		total_records: 0,
		total_pages: 0,
		current_page: 1,
		per_page: 100,
	},
	_cache: {},
	is_fetching: false,
	active: undefined,
	customUnits: [],
	isLoadingCustomUnits: false,
}

export default (state = initialState, action) => {
	const { type } = action
	switch (type) {
		case 'SET_LOADING_UNITS': {
			var { payload } = action

			return {
				...state,
				isLoadingCustomUnits: payload,
			}
		}
		case 'SET_CUSTOM_UNITS': {
			var { payload } = action

			return {
				...state,
				customUnits: payload,
			}
		}
		case 'UPDATE_UNIT_EMPLOYEE': {
			var { response, payload } = action

			return {
				...state,
				is_fetching: false,
				unit_driver: response,
			}
		}
		case 'ADD_UNIT_EMPLOYEE': {
			var { response, payload } = action

			return {
				...state,
				is_fetching: false,
				unit_driver: response,
			}
		}
		case 'GET_UNIT_TYPES': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				types: response,
			}
		}

		case 'GET_UNITS_WIALON': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				wialon: response.error ? [] : response,
			}
		}

		case 'GET_UNITS_XIGA': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				xiga: response.error ? [] : response,
			}
		}

		case 'GET_UNIT_WIALON': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				wialon: response.error ? [] : response,
			}
		}

		case 'GET_DRIVER_UNITS': {
			var { response } = action

			return {
				...state,
				is_fetching: false,
				driver_units: response,
			}
		}

		case 'GET_UNIT_ODOMETER_HISTORY': {
			var { response } = action

			return {
				...state,
				last_unit_odometer_history: response.last_odometer_values,
			}
		}

		case 'GET_UNIT_HOURMETER_HISTORY': {
			var { response } = action

			return {
				...state,
				last_unit_hourmeter_history: response.last_hourmeter_values,
			}
		}

		case 'GET_ALL_UNITS': {
			return {
				...state,
				entities: action.payload
			}
		}

		case 'GET_ODOMETERS_UNITS_PAGE': {
			return {
				...state,
				odometers_units_page: action.payload
			}
		}
		default:
			state = crudHandlers(state, action, 'unit')

			return state
	}
}
